import React from "react";
import styled from "styled-components";

const Label = styled.label`
  margin-bottom: 0.5em;
  color: black;
  display: block;
`;

const SelectField = styled.select`
  padding: 0.5em;
  color: black;
  border: none;
  width: 30%;
  margin-bottom: 0.5em;
  font-weight: 500;
  background-color: rgb(84, 102, 253);
  color: rgb(255, 255, 255);
  border-radius: 12px;
`;

const Select = (props) => {
  const onChangeHandler = (event) => {
    props.onChange(event.target.value);
  };

  const mapedOptions = props.options.map((item) => {
    return (
      <option key={item} value={item}>
        {item}
      </option>
    );
  });

  return (
    <span>
      <Label htmlFor={props.id}>{props.label}</Label>
      <SelectField
        name={props.id}
        id={props.id}
        value={props.value}
        onChange={onChangeHandler}
      >
        {mapedOptions.length !== 0 ? (
          mapedOptions
        ) : (
          <option key={props.value} value={props.value}>
            {props.value}
          </option>
        )}
      </SelectField>
    </span>
  );
};

export default Select;
